import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ComexBankFeeLog from './comex-bank-fee-log';
import ComexBankFeeLogDetail from './comex-bank-fee-log-detail';
import ComexBankFeeLogUpdate from './comex-bank-fee-log-update';
import ComexBankFeeLogDeleteDialog from './comex-bank-fee-log-delete-dialog';
import PrivateRoute from 'app/shared/auth/private-route';
import { AUTHORITIES } from 'app/config/constants';

const Routes = ({ match }) => (
  <>
    <Switch>
      <PrivateRoute
        exact
        path={`${match.url}/:id`}
        component={ComexBankFeeLogDetail}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.AUDITOR]}
      />
      <PrivateRoute path={match.url} component={ComexBankFeeLog} hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.AUDITOR]} />
    </Switch>
  </>
);

export default Routes;
